export const REGLAGES_BULLES_PROJET_DEFAUTS = Object.freeze ({
  couleurs_auto : [],
  taille_bulle_min : 24,
  taille_bulle_max : 200,
  taille_bulle_custom_defaut : 120,
  rotation_bulle_min : 0,
  rotation_bulle_max : 0,
  ombre_active : false,
  ombre_opacite : 0.4,
  ombre_blur : 1,
  ombre_x : 3,
  ombre_y : 3,
  ombre_couleur : "#000000",
  ombre_zones_dessinees_seules : true,
  lecture_flottement_vitesse_deplacement : 1,
  lecture_flottement_deplacement_max_x : 0,
  lecture_flottement_deplacement_max_y : 2,
  lecture_flottement_vitesse_taille : 1,
  lecture_flottement_taille_min_pct : 100,
  lecture_flottement_taille_max_pct : 100,
  lecture_flottement_vitesse_rotation : 1,
  lecture_flottement_rotation_min_pct : 70,
  lecture_flottement_rotation_max_pct : 130,
});

function normalise_nombre_taille_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (1, Math.min (320, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_rotation_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (-180, Math.min (180, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_vitesse_flottement_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (0, Math.min (6, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_deplacement_flottement_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (0, Math.min (120, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_pourcentage_flottement_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (10, Math.min (300, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_opacite_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (0, Math.min (1, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_flou_ombre_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (0, Math.min (80, tNombre)) * 1000) / 1000;
  }

function normalise_nombre_decalage_ombre_bulle_projet (pValeur, pFallback)
  {
    const tNombre = Number (pValeur);
    if (!Number.isFinite (tNombre)) return pFallback;
    return Math.round (Math.max (-200, Math.min (200, tNombre)) * 1000) / 1000;
  }

function normalise_couleur_hex_bulle_projet (pValeur)
  {
    const tValeur = typeof pValeur === "string" ? pValeur.trim ().toLowerCase () : "";
    return /^#[0-9a-f]{6}$/.test (tValeur) ? tValeur : null;
  }

export function normalise_reglages_bulles_projet (pValeur)
  {
    const tSource = (pValeur && typeof pValeur === "object" && !Array.isArray (pValeur))
      ? pValeur
      : {};
    const tCouleursBrutes = Array.isArray (tSource.couleurs_auto)
      ? tSource.couleurs_auto
      : (Array.isArray (tSource.couleurs) ? tSource.couleurs : []);
    const tVues = new Set ();
    const tCouleurs = [];

    tCouleursBrutes.forEach ((pCouleur) =>
      {
        const tCouleur = normalise_couleur_hex_bulle_projet (pCouleur);
        if (!tCouleur || tVues.has (tCouleur)) return;
        tVues.add (tCouleur);
        tCouleurs.push (tCouleur);
      });

    const tMinInitial = normalise_nombre_taille_bulle_projet (
      tSource.taille_bulle_min,
      REGLAGES_BULLES_PROJET_DEFAUTS.taille_bulle_min
    );
    const tMaxInitial = normalise_nombre_taille_bulle_projet (
      tSource.taille_bulle_max,
      REGLAGES_BULLES_PROJET_DEFAUTS.taille_bulle_max
    );
    const tMin = Math.min (tMinInitial, tMaxInitial);
    const tMax = Math.max (tMinInitial, tMaxInitial);
    const tCustomBrut = normalise_nombre_taille_bulle_projet (
      tSource.taille_bulle_custom_defaut,
      REGLAGES_BULLES_PROJET_DEFAUTS.taille_bulle_custom_defaut
    );
    const tCustom = Math.max (tMin, Math.min (tMax, tCustomBrut));
    const tRotationMinInitial = normalise_nombre_rotation_bulle_projet (
      tSource.rotation_bulle_min,
      REGLAGES_BULLES_PROJET_DEFAUTS.rotation_bulle_min
    );
    const tRotationMaxInitial = normalise_nombre_rotation_bulle_projet (
      tSource.rotation_bulle_max,
      REGLAGES_BULLES_PROJET_DEFAUTS.rotation_bulle_max
    );
    const tRotationMin = Math.min (tRotationMinInitial, tRotationMaxInitial);
    const tRotationMax = Math.max (tRotationMinInitial, tRotationMaxInitial);
    const tOmbreActive = typeof tSource.ombre_active === "boolean"
      ? tSource.ombre_active
      : REGLAGES_BULLES_PROJET_DEFAUTS.ombre_active;
    const tOmbreOpacite = normalise_nombre_opacite_bulle_projet (
      tSource.ombre_opacite,
      REGLAGES_BULLES_PROJET_DEFAUTS.ombre_opacite
    );
    const tOmbreBlur = normalise_nombre_flou_ombre_bulle_projet (
      tSource.ombre_blur,
      REGLAGES_BULLES_PROJET_DEFAUTS.ombre_blur
    );
    const tOmbreX = normalise_nombre_decalage_ombre_bulle_projet (
      tSource.ombre_x,
      REGLAGES_BULLES_PROJET_DEFAUTS.ombre_x
    );
    const tOmbreY = normalise_nombre_decalage_ombre_bulle_projet (
      tSource.ombre_y,
      REGLAGES_BULLES_PROJET_DEFAUTS.ombre_y
    );
    const tOmbreCouleur = normalise_couleur_hex_bulle_projet (tSource.ombre_couleur)
      || REGLAGES_BULLES_PROJET_DEFAUTS.ombre_couleur;
    const tOmbreZonesDessineesSeules = typeof tSource.ombre_zones_dessinees_seules === "boolean"
      ? tSource.ombre_zones_dessinees_seules
      : REGLAGES_BULLES_PROJET_DEFAUTS.ombre_zones_dessinees_seules;
    const tLectureVitesseDeplacement = normalise_nombre_vitesse_flottement_bulle_projet (
      tSource.lecture_flottement_vitesse_deplacement,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_vitesse_deplacement
    );
    const tLectureDeplacementMaxX = normalise_nombre_deplacement_flottement_bulle_projet (
      tSource.lecture_flottement_deplacement_max_x,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_deplacement_max_x
    );
    const tLectureDeplacementMaxY = normalise_nombre_deplacement_flottement_bulle_projet (
      tSource.lecture_flottement_deplacement_max_y,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_deplacement_max_y
    );
    const tLectureVitesseTaille = normalise_nombre_vitesse_flottement_bulle_projet (
      tSource.lecture_flottement_vitesse_taille,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_vitesse_taille
    );
    const tLectureTailleMinInitial = normalise_nombre_pourcentage_flottement_bulle_projet (
      tSource.lecture_flottement_taille_min_pct,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_taille_min_pct
    );
    const tLectureTailleMaxInitial = normalise_nombre_pourcentage_flottement_bulle_projet (
      tSource.lecture_flottement_taille_max_pct,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_taille_max_pct
    );
    const tLectureTailleMin = Math.min (tLectureTailleMinInitial, tLectureTailleMaxInitial);
    const tLectureTailleMax = Math.max (tLectureTailleMinInitial, tLectureTailleMaxInitial);
    const tLectureVitesseRotation = normalise_nombre_vitesse_flottement_bulle_projet (
      tSource.lecture_flottement_vitesse_rotation,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_vitesse_rotation
    );
    const tLectureRotationMinInitial = normalise_nombre_pourcentage_flottement_bulle_projet (
      tSource.lecture_flottement_rotation_min_pct,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_rotation_min_pct
    );
    const tLectureRotationMaxInitial = normalise_nombre_pourcentage_flottement_bulle_projet (
      tSource.lecture_flottement_rotation_max_pct,
      REGLAGES_BULLES_PROJET_DEFAUTS.lecture_flottement_rotation_max_pct
    );
    const tLectureRotationMin = Math.min (tLectureRotationMinInitial, tLectureRotationMaxInitial);
    const tLectureRotationMax = Math.max (tLectureRotationMinInitial, tLectureRotationMaxInitial);

    return {
      ...REGLAGES_BULLES_PROJET_DEFAUTS,
      couleurs_auto : tCouleurs,
      taille_bulle_min : tMin,
      taille_bulle_max : tMax,
      taille_bulle_custom_defaut : tCustom,
      rotation_bulle_min : tRotationMin,
      rotation_bulle_max : tRotationMax,
      ombre_active : tOmbreActive,
      ombre_opacite : tOmbreOpacite,
      ombre_blur : tOmbreBlur,
      ombre_x : tOmbreX,
      ombre_y : tOmbreY,
      ombre_couleur : tOmbreCouleur,
      ombre_zones_dessinees_seules : tOmbreZonesDessineesSeules,
      lecture_flottement_vitesse_deplacement : tLectureVitesseDeplacement,
      lecture_flottement_deplacement_max_x : tLectureDeplacementMaxX,
      lecture_flottement_deplacement_max_y : tLectureDeplacementMaxY,
      lecture_flottement_vitesse_taille : tLectureVitesseTaille,
      lecture_flottement_taille_min_pct : tLectureTailleMin,
      lecture_flottement_taille_max_pct : tLectureTailleMax,
      lecture_flottement_vitesse_rotation : tLectureVitesseRotation,
      lecture_flottement_rotation_min_pct : tLectureRotationMin,
      lecture_flottement_rotation_max_pct : tLectureRotationMax,
    };
  }
